export const isZero = (value?: number) => value !== undefined && Math.abs(value) < 0.001;

export const isClose = (valueA?: number, valueB?: number) =>
  valueA !== undefined && valueB !== undefined && isZero(valueA - valueB);
